export default __webpack_public_path__ + "static/media/banner-ub-2.9ba2bf98.jpg";